export default __webpack_public_path__ + "static/media/breach4.6723d7c9.png";